const normalizeExternalBaseUrl = (value?: string): string => value?.trim().replace(/\/+$/, '') ?? '';

const openPendingTab = (provider: 'aws' | 'azure' = 'aws'): Window | null => {
  const popup = window.open('', '_blank');
  if (!popup) {
    return null;
  }
  try {
    popup.document.title = provider === 'azure' ? 'Opening Azure Portal…' : 'Opening AWS Console…';
    const message = provider === 'azure' ? 'Opening Azure setup…' : 'Opening AWS CloudFormation…';
    popup.document.body.innerHTML = `<p style="font-family: sans-serif; padding: 16px;">${message}</p>`;
  } catch {
    // Ignore browser-specific restrictions on interim popup content.
  }
  return popup;
};

const navigatePendingTab = (popup: Window | null, url: string): boolean => {
  try {
    if (popup && !popup.closed) {
      popup.location.href = url;
      popup.focus();
      return true;
    }
  } catch {
    // Fall through to a fresh open attempt.
  }
  const reopened = window.open(url, '_blank', 'noopener,noreferrer');
  return Boolean(reopened);
};

export { navigatePendingTab, normalizeExternalBaseUrl, openPendingTab };
